<template>
    <div class="map content-cut-off">
        <gmap-map
            :center="center"
            :zoom="10"
            ref="map"
        >
            <gmap-info-window
                @closeclick="infoWinOpen = false"
                :opened="infoWindowOpen"
                :options="infoOptions"
                :position="infoWindowPos"
            />

            <gmap-marker
                v-for="(m, index) in markers"
                @click="toggleInfoWindow(m, index)"
                :key="index"
                :position="m.position"
                :clickable="true"
            />
        </gmap-map>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        name: 'GoogleMaps',
        data() {
            return {
                center: {
                    lat: 52.027571,
                    lng: 5.235293,
                },
                currentMidx: null,
                infoOptions: {
                    content: '',
                    pixelOffset: {
                        height: -35,
                        width: 0,
                    },
                },
                infoWindowPos: null,
                infoWindowOpen: false,
                markers: [],
            };
        },
        async mounted() {
            const { data } = await axios.get('/wp-json/wp-store-finder/v1/get');

            const dataFiltered = data.filter(item => item.position.lat);

            dataFiltered.forEach((item) => {
                item.position.lat = parseFloat(item.position.lat);
                item.position.lng = parseFloat(item.position.lng);
                item.infoText = `
                    <h2>${item.name}</h2>
                    <p>
                        ${item.address}
                        <br>
                        ${item.zipcode}, ${item.city}
                    </p>
                `;
            });

            this.markers = dataFiltered;

            const bounds = new google.maps.LatLngBounds();

            this.markers.forEach((marker) => {
                bounds.extend(marker.position);
            });

            this.$refs.map.fitBounds(bounds);
        },
        methods: {
            toggleInfoWindow(marker, idx) {
                this.infoWindowPos = marker.position;
                this.infoOptions.content = marker.infoText;

                if (this.currentMidx === idx) {
                    this.infoWindowOpen = !this.infoWindowOpen;
                } else {
                    this.infoWindowOpen = true;
                    this.currentMidx = idx;
                }
            },
        },
    };
</script>
